import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page Not Found - Promptliteracy.ai</title>
        <meta name="description" content="The page you're looking for could not be found." />
      </Helmet>
      
      <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background decorations */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5" />
        <div className="absolute top-20 right-20 w-32 h-32 bg-primary/20 rounded-full blur-3xl animate-pulse-tech" />
        <div className="absolute bottom-20 left-20 w-40 h-40 bg-secondary/15 rounded-full blur-3xl animate-float" />
        
        <div className="container relative z-10 text-center">
          <div className="max-w-md mx-auto">
            <h1 className="text-8xl font-bold gradient-text-tech mb-4">404</h1>
            <h2 className="text-3xl font-bold text-primary mb-4">Page Not Found</h2>
            <p className="text-muted-foreground mb-8 text-lg leading-relaxed">
              The page you're looking for doesn't exist or has been moved.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild className="btn-tech hover-lift">
                <Link to="/">
                  <Home className="mr-2 h-4 w-4" />
                  Go Home
                </Link>
              </Button>
              <Button variant="outline" asChild className="border-slate-300 btn-blue-hover transition-colors hover-lift">
                <Link to="/news">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Browse News
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}